
import ReactGoogleRecaptcha from 'react-google-recaptcha';
import React, { Component } from 'react';
import _ from 'lodash';

export default class Recaptcha extends Component {

  constructor(props) {
    super(props);

    this.sitekey = (
      process.env.CMC_PORTAL_ENV === 'staging' ||
      process.env.CMC_PORTAL_ENV === 'local' ||
      process.env.CMC_PORTAL_ENV === 'test' ||
      process.env.CMC_PORTAL_ENV === 'build'
    ) ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : '6LfrCGoUAAAAAEky6vQC8qibJcJJjDj_n8PuiBZJ';

    this.state = {
      token: undefined,
      showCaptchaError: false,
    };
  }

  reset() {
    if (this.reCaptchaInstance){
      this.reCaptchaInstance.reset();
    }
  }

  afterTokenChange(token) {
    const { onChange } = this.props;
    if (_.isFunction(onChange)) {
      onChange(token);
    }
  }

  onErrored() {
    this.setState({
      showCaptchaError: true,
    });
  }

  onChange(token) {

    if (token) {
      // captcha completed
      this.setState({
        token,
      }, () => {
        this.afterTokenChange(token);
      });
    } else {
      // expired or reset
      this.setState({
        token: undefined,
      }, () => {
        this.reset();
        this.afterTokenChange(null);
      });
    }

  }

  componentWillUnmount() {
    // hack fix here to make sure reCaptcha resets before component unmounts
    this.reCaptchaInstance.reset();

    // and then we must unset our widgetId or else ReCAPTCHA.prototype.reset will crash
    this.reCaptchaInstance._widgetId = undefined;
  }

  render() {
    // tap into reCAPTCHA work around domain recaptcha.net https://developers.google.com/recaptcha/docs/faq
    // Note: If you are testing it outside of CN, it will use www.google.com
    if (global.window){
      global.window.recaptchaOptions = {
        useRecaptchaNet: true,
      };
    }

    if (!this.state.showCaptchaError) {
      return (
        <div className="recaptcha">
          <ReactGoogleRecaptcha
            ref={(el) => {this.reCaptchaInstance = el;}}
            sitekey={this.sitekey}
            onChange={this.onChange.bind(this)}
            onErrored={this.onErrored.bind(this)} />
        </div>
      );
    } else {
      return (
        <div key="danger" className="alert alert-danger">
          <p>Google reCAPTCHA failed to load. Please refresh the page or contact api@coinmarketcap.com if this problem persists.</p>
        </div>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./client/components/Recaptcha.jsx